<h1 mat-dialog-title #ttt>{{data.title}}</h1>
<div [style.max-height]="'calc(100vh - ' + (ttt.clientHeight + fff.clientHeight) + 'px)'" mat-dialog-content>
    <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions #fff>
    <div style="display: flex;width: 100%;justify-content: flex-end;">
        <button mat-button (click)="onNoClick()">Schließen</button>
    </div>
</div>